export default __webpack_public_path__ + "static/media/Bot-Avatar2.42ef02e5.png";